import { useState } from "react";
import { toast } from "sonner";
import { Ticket, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel } from "@/components/Shared";
import { inputCls, btnPrimary } from "@/components/Form";

export default function RedeemCode() {
  const { user, refresh } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/codes/redeem", { code });
      toast.success(data.message); setCode(""); await refresh();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Panel title="Tenho um código" sub="Ative uma licença ou ganhe contestações grátis com um código." icon={Ticket} testid="redeem-panel">
      <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row">
        <input data-testid="redeem-code-input" required minLength={3} placeholder="Ex.: CF-7K2P-9QXA" className={`${inputCls} font-mono uppercase`} value={code} onChange={(e) => setCode(e.target.value)} />
        <button data-testid="redeem-code-btn" disabled={busy} className={`${btnPrimary} shrink-0`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />}Resgatar</button>
      </form>
      {user.bonus_credits > 0 && <p className="mt-3 text-sm text-emerald-700" data-testid="bonus-credits-text">Você tem <b>{user.bonus_credits}</b> contestações bônus disponíveis.</p>}
    </Panel>
  );
}
